<template>
  <section class="terms">
    <table class="table-new">
      <caption>
        민감정보 수집 및 이용 동의
      </caption>
      <colgroup>
        <col width="33%" />
        <col width="33.4%" />
        <col width="33%" />
      </colgroup>
      <thead>
      <tr>
        <th>수집 항목</th>
        <th>이용 목적</th>
        <th>보유 및 이용 기간</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <u class="primary--text">
            여행지원서
            문항별 응답값,
            미션 문항별 응답값
          </u>
        </td>
        <td>
          후유 서비스 제공
        </td>
        <td>
          <u class="primary--text">
            (일반회원) 회원 탈퇴시 까지<br /><br />
            (기업회원) (위탁)서비스 계약 종료 후 3년
          </u>
        </td>
      </tr>
      <tr>
      </tr>
      </tbody>
    </table>
    <p class="desc">
      이용자는 민감정보 수집 및 이용 동의를 거부할 권리가 있으며, 동의 거부 시 후유 서비스 이용이 제한 될 수 있습니다.
    </p>
  </section>
</template>

<script>
export default {
  name: 'SensitiveTerms'
}
</script>
